export default __webpack_public_path__ + "static/media/P-041.c95a0eef.png";